import { render } from "./moov-card-form.vue?vue&type=template&id=36f32b64&scoped=true"
import script from "./moov-card-form.vue?vue&type=script&lang=js"
export * from "./moov-card-form.vue?vue&type=script&lang=js"

import "./moov-card-form.vue?vue&type=style&index=0&id=36f32b64&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f32b64"]])

export default __exports__